import axios from "axios";

// Base API URL
export const API_BASE = process.env.REACT_APP_API_URL;

// Create axios instance
export const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const sessionToken = localStorage.getItem("session_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (sessionToken) {
      config.headers["Session-Token"] = sessionToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Global response handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }

    if (status === 409) {
      window.dispatchEvent(new Event("session-conflict"));
    }

    if (error.response?.status === 403) {
      window.dispatchEvent(
        new CustomEvent("permission-denied", {
          detail: error.response.data.permission,
        })
      );
    }

    return Promise.reject(error);
  }
);
export default api;